let colors = require("../../assets/colors.json")

let Colorful = function() {
  this.colors = colors
}

let colorPalette = function(color) {
  return colors[color]
}

export { colorPalette }

export default Colorful;
